<template>
  <div class="bg-black h-screen">
    <ins-header :title="headerTitle" @back="goBack"></ins-header>
    <div
      class="transac-amount-s"
      style="margin-top: -26px"
      v-html="transactionData.amount"
    ></div>
    <p class="color-w">ریال</p>
    <div
      class="overflow-hidden flex items-center justify-center trans-card dir-rtl"
    >
      <div style="width: 88%">
        <div class="from">
          <div class="source-s">
            <p style="float: right">از</p>
            <img :src="sourceAccount.bank.avatar" />
            <p>{{ sourceAccount.name }}</p>
          </div>
          <div class="dest-s">
            <p style="float: right">به</p>
            <p>{{ transactionData.user.keyword }}~</p>
          </div>
          <table style="width: 92%; margin: auto">
            <tr>
              <td style="float: right">تاریخ وساعت</td>
              <td>{{ transactionData.finish_time }}</td>
            </tr>
            <tr>
              <td style="float: right">کارمزد تراکنش</td>
              <td>{{ transactionData.commission }}</td>
            </tr>
            <tr>
              <td style="float: right">شماره تراکنش</td>
              <td>{{ transactionData.trace_id }}</td>
            </tr>
          </table>
        </div>
        <div class="about-s">
          <p style="margin-top: 10px; margin-bottom: 10px">بابت:</p>
          <br />
          <br />
          <p>
            {{ transactionData.reason }}
          </p>

          <button
            style="margin-top: 12%; margin-bottom: 15%"
            class="m-btn"
            @click="goHome"
          >
            تایید
          </button>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  props: {
    data: [],
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {
      transactionData: {},
      sourceAccount: {},
    };
  },
  beforeMount() {
    this.transactionData = this.$store.state.transaction.transaction;
    this.sourceAccount = this.$store.state.transaction.sourceAccount;
  },
  methods: {
    goHome() {
      this.$router.push({ name: "Home" });
    },
  },
  components: {
    InsHeader,
  },
};
</script>
